.panelCard {
  background: #ffffff;
  border-radius: 16px;
  margin-top: 1.5rem;
  padding: 24px;
}

@media (max-width: 599px) {
  .panelCard {
    padding: 16px;
  }
}
